import { partfinitiClient } from './partfinitiClient';

export const getLogoPaths = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/common/custom-config/logo-paths`,
    signal
  );

  return data.logo_paths;
};
